<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
<template>
    <v-card flat>
        <v-container fluid>
            <v-row v-if="license == null && userData.license == null">
                <v-col>
                    <v-btn  color="primary" @click="onClickEnableLicense"><v-icon>mdi-plus-circle-outline</v-icon>ライセンスの有効化</v-btn>
                </v-col>
            </v-row>
            <v-row v-if="license != null">
                <v-col v-if="userData.license.isLicenseManager" cols="12">
                    <v-card class="pa-1">
                        <Title title="ライセンス" dense />
                        <v-card-text>
                            <table v-if="!$vuetify.breakpoint.xs" style="width:100%">
                                <tr>
                                    <td>ライセンスコード</td>
                                    <td>組織名称</td>
                                    <td>有効化日時</td>
                                    <td>有効期限</td>
                                    <td>ライセンス数</td>
                                </tr>
                                <tr>
                                    <td>{{license.body.code}}</td>
                                    <td>{{license.body.organization.name}}</td>
                                    <td>{{license.body.licenseInfo.activatedDateTime}}</td>
                                    <td>{{license.body.licenseInfo.toDate}}</td>
                                    <td class="text-center">{{enabledUserNum()}} / {{license.body.licenseInfo.licenseNum}}</td>
                                </tr>
                            </table>
                            <table v-else>
                                <tr>
                                    <td>ライセンスコード</td>
                                    <td>{{license.body.code}}</td>
                                </tr>
                                <tr>
                                    <td>組織名称</td>
                                    <td>{{license.body.organization.name}}</td>
                                </tr>
                                <tr>
                                    <td>有効化日時</td>
                                    <td>{{license.body.licenseInfo.activatedDateTime}}</td>
                                </tr>
                                <tr>
                                    <td>有効期限</td>
                                    <td>{{license.body.licenseInfo.toDate}}</td>
                                </tr>
                                <tr>
                                    <td>ライセンス数</td>
                                    <td>{{enabledUserNum()}} / {{license.body.licenseInfo.licenseNum}}</td>
                                </tr>
                            </table>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn color="primary" @click="onClickChangePassword" class="ml-2"><v-icon>mdi-lock-question</v-icon>パスワード変更</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col v-else cols="12">
                    <v-card class="pa-1">
                        <Title title="ライセンス" dense />
                        <v-card-text>
                            <table v-if="!$vuetify.breakpoint.xs" style="width:100%">
                                <tr>
                                    <td>ライセンスコード</td>
                                    <td>組織名称</td>
                                    <td>有効期限</td>
                                </tr>
                                <tr>
                                    <td>{{license.body.code}}</td>
                                    <td>{{license.body.organization.name}}</td>
                                    <td>{{license.body.licenseInfo.toDate}}</td>
                                </tr>
                            </table>
                            <table v-else>
                                <tr>
                                    <td>ライセンスコード</td>
                                    <td>{{license.body.code}}</td>
                                </tr>
                                <tr>
                                    <td>組織名称</td>
                                    <td>{{license.body.organization.name}}</td>
                                </tr>
                                <tr>
                                    <td>有効期限</td>
                                    <td>{{license.body.licenseInfo.toDate}}</td>
                                </tr>
                            </table>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col v-if="userData.license.isLicenseManager">
                    <v-card class="pa-1">
                        <Title title="ライセンス認証されたユーザー" dense />
                        <v-card-text>
                            <v-simple-table v-if="!$vuetify.breakpoint.xs" fixed-header height="400">
                                <thead>
                                    <tr>
                                        <th style="width:100%">ユーザー</th>
                                        <th>有効日</th>
                                        <th>状態</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="user in license.users" :key="user.body.userUID" @click="onSelectedLicensedUser(user)">
                                        <td>
                                            <v-avatar class="ma-0" size="24" rounded>
                                                <v-img v-if="user.userInfo.avaterURL == null" src="@/assets/no_avater_image.png"/>
                                                <v-img v-if="user.userInfo.avaterURL != null" :src="user.userInfo.avaterURL"/>
                                            </v-avatar>
                                            {{user.userInfo.userName}}
                                        </td>
                                        <td>{{user.body.license.dateTime}}</td>
                                        <td>
                                            <v-chip v-if="user.isExclusion" label color="warning">無効</v-chip>
                                            <v-chip v-else label color="primary">有効</v-chip>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                            <v-simple-table v-else fixed-header height="200">
                                <tbody>
                                    <tr>
                                        <td>
                                            <v-container fluid class="pa-0">
                                                <v-row dense>
                                                    <v-col cols="12">
                                                        <v-card class="ma-1" v-for="user in license.users" :key="user.body.userUID" @click="onSelectedLicensedUser(user)">
                                                            <v-card-text class="pa-1" style="font-size:xx-small">
                                                                <table>
                                                                    <tr style="font-size:small">
                                                                        <td colspan="2">{{user.userInfo.userName}}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>有効日:</td>
                                                                        <td style="width:100%">{{user.body.license.dateTime}}</td>
                                                                        <td>状態:</td>
                                                                        <td>
                                                                            <v-chip v-if="user.isExclusion" label color="warning">無効</v-chip>
                                                                            <v-chip v-else label color="primary">有効</v-chip>
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                            </v-card-text>
                                                        </v-card>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <VerificatorLicense ref="verificator" />
        <ChangePassword ref="changePassword" />
        <Confirm ref="confirm" />
    </v-card>
</template>

<script>
    Date.prototype.toFormatString = function (format) {
        const year = this.getFullYear()
        const month = this.getMonth() + 1
        const month2 = ("0" + month).slice(-2)
        const day2 = ("0" + this.getDate()).slice(-2)
        const hour2 = ("0" + this.getHours()).slice(-2)
        const minute2 = ("0" + this.getMinutes()).slice(-2)
        const second2 = ("0" + this.getSeconds()).slice(-2)

        const formattedValue = format.replace("yyyy", year).replace("MM", month2).replace("dd", day2).replace("HH", hour2).replace("mm", minute2).replace("ss", second2)

        return formattedValue
    }

    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import VerificatorLicense from '@/components/tools/LicenseVerificator';
    import ChangePassword from '@/components/setting/items/ChangeLicensePassword';
    import Confirm from '@/components/tools/ConfirmDialog';
    export default {
        components: {
            VerificatorLicense,
            ChangePassword,
            Confirm,
            Title
        },
        data: function () {
            return {
                /** 有効化しているライセンス */
                license: null
            }
        },
        computed: {
            userUID: function () {
                return this.$store.getters["loggedInUserUID"]
            },
            userData: function () {
                return this.$store.getters["loggedInUserData"]
            },
            userLicense: function () {
                return this.$store.getters["loggedInUserLicense"]
            },
        },
        created: function () {
            if (this.userLicense == null) {
                this.license = null
                return
            }
            this.license = {
                body: this.userLicense,
                users: []
            }
            console.log("License", "created", "license data", this.license)
            if (!this.userData.license.isLicenseManager) {
                return
            }
            
            const self = this

            // 除外リストの全データを取得
            const exclusionUserList = []
            db.collection("licenses").doc(this.userData.license.code).collection("exclusion_users").get().then(function(refExclusionUsers){
                for (var i=0; i<refExclusionUsers.size; i++) {
                    exclusionUserList.push(refExclusionUsers.docs[i].data())
                }
                // 取得後、このライセンスを持つ全ユーザーを取得
                db.collection("users").where("license.code", "==", self.userData.license.code).orderBy("license.dateTime").get().then(function(snapShot){
                    self.license = {
                        body: self.userLicense,
                        users: [],
                    }
                    snapShot.forEach(function(docUser){
                        const user = docUser.data()
                        const userData = {
                            body: user,
                            isExclusion: exclusionUserList.findIndex((v)=>v.userUID == user.userUID) >= 0 ? true : false,
                            userInfo: {
                                userName: "",
                                avaterURL: ""
                            }
                        }
                        self.mi_userData(user.userUID, userData.userInfo)
                        self.license.users.push(userData)
                    })
                }).catch (function(error) {
                    self.mi_writeLog("License/created", "ライセンスのユーザー取得失敗("+error+")")
                })
            }).catch (function(error) {
                self.mi_writeLog("License/created", "ライセンスの除外ユーザー取得失敗("+error+")")
            })
        },
        methods: {
            /**
             * ライセンス有効化ボタン押下時
             */
            onClickEnableLicense: function () {
                this.$refs.verificator.show(this.verificatedLicense)
            },
            /**
             * パスワード変更ボタン押下時
             */
            onClickChangePassword: function () {
                this.$refs.changePassword.show(this.license.body)
            },
            /**
             * ライセンス認証されたユーザー選択時
             */
            onSelectedLicensedUser: function (user) {
                var confirmMessage = ""
                var buttonText = ""
                if (user.isExclusion) {
                    // 現在ライセンス除外されているユーザーの時
                    // ※但し、既に有効なユーザー数がライセンス数上限に達している時は不可
                    if (this.enabledUserNum() >= this.license.body.licenseInfo.licenseNum) {
                        this.$refs.confirm.show({
                            title: "ライセンス上限",
                            message: "既にライセンスの上限に達しているので<br/>このユーザーのライセンスを有効に設定出来ません。",
                            buttonYes: "戻る",
                            buttonNo: ""
                        })
                        return
                    }
                    confirmMessage = "このユーザーのライセンスを有効にしますか？"
                    buttonText = "有効にする"
                } else {
                    // 現在ライセンス有効のユーザーの時
                    confirmMessage = "このユーザーのライセンスを無効にしますか？"
                    buttonText = "無効にする"
                }
                const self = this
                this.$refs.confirm.show({
                    title: "ユーザーのライセンス設定",
                    message: confirmMessage,
                    width: 450,
                    buttonYes: buttonText,
                    buttonNo: "しない",
                    listenerYes: function () {
                        self.updateUserLicenseState(user)
                        return true
                    },
                })
            },
            /**
             * 指定されたユーザーのライセンス状態を更新
             * (ライセンス有効な時は、無効にする。 無効の時は、有効にする。)
             */
            updateUserLicenseState: function (user) {
                console.log("License", "updateUserLicenseState", user)
                const self = this
                if (user.isExclusion) {
                    // 現在ライセンス除外されているユーザーの時は、除外データを削除して有効にする
                    db.collection("licenses").doc(this.license.body.code).collection("exclusion_users").doc(user.body.userUID).delete().then(function(){
                        self.$store.commit("notification", {message:"このユーザーのライセンスを有効にしました。", isError: false})
                        user.isExclusion = false
                    }).catch (function (error) {
                        console.log(error)
                        self.$store.commit("notification", {message:"このユーザーのライセンスを有効に出来ませんでした。"+error, isError: true})
                    })
                } else {
                    // 現在ライセンス有効なユーザーの時は、除外データを登録して無効にする
                    const currentDateTime = new Date()
                    const exclusionData = {
                        version: "1.0.0",
                        userUID: user.body.userUID,
                        registeredDateTime: currentDateTime.toFormatString("yyyy-MM-dd HH:mm:ss")
                    }
                    db.collection("licenses").doc(this.license.body.code).collection("exclusion_users").doc(user.body.userUID).set(exclusionData).then(function(){
                        self.$store.commit("notification", {message:"このユーザーのライセンスを無効にしました。", isError: false})
                        user.isExclusion = true
                    }).catch (function (error) {
                        console.log(error)
                        self.$store.commit("notification", {message:"このユーザーのライセンスを無効に出来ませんでした。"+error, isError: true})
                    })
                }
            },
            /**
             * ライセンスを使用している有効なユーザー数を返す
             */
            enabledUserNum: function () {
                var num = 0
                for (var i=0; i<this.license.users.length; i++) {
                    if (!this.license.users[i].isExclusion) {
                        num++
                    }
                }
                return num
            },
            /**
             * ライセンス認証画面での認証結果を受け取るコールバック
             */
            verificatedLicense: function (result) {
                
                const self = this

                switch (result.result) {
                    case "ERROR_LICENSE_0001":
                    case "ERROR_LICENSE_0002":
                        this.showLicenseNG(result.result)
                        return
                }
                /** ライセンスデータ有り、パスワードOKの時は既に有効化されているかをチェック */
                if (result.license.licenseInfo.activated) {
                    this.showLicenseNG("ERROR_LICENSE_0003")
                    return
                }

                /** ライセンスデータに値を設定してデータベースを更新 */
                const currentDateTime = new Date()
                result.license.licenseInfo.date = currentDateTime.toFormatString("yyyy-MM-dd")
                result.license.licenseInfo.activated = true
                result.license.licenseInfo.activatedUserUID = this.$store.getters["userUID"]
                result.license.licenseInfo.activatedDateTime = currentDateTime.toFormatString("yyyy-MM-dd HH:mm:ss")

                db.collection("licenses").doc(result.license.code).set(result.license).then(function(){
                    self.$store.commit("notification", {message:"ライセンスを有効化しました。", isError: false})
                    // ユーザーデータのライセンスに、このライセンスをセット
                    const userData = self.$store.getters["userData"]
                    userData.license = {
                        code: result.license.code,
                        isLicenseManager: true,
                        dateTime: currentDateTime.toFormatString("yyyy-MM-dd HH:mm:ss")
                    }
                    db.collection("users").doc(userData.userUID).set(userData).then(function(){
                        self.$store.commit("userLicense", result.license)
                    }).catch (function(error){
                        self.$store.commit("notification", {message:"ライセンスの設定に失敗しました。"+error, isError: true})
                    })
                }).catch (function(error) {
                    console.log(error)
                    self.$store.commit("notification", {message:"ライセンスの有効化に失敗しました。"+error, isError: true})
                })
            },
            /**
             * ライセンス不可時のダイアログを表示
             */
            showLicenseNG: function (result) {
                this.$refs.confirm.show({
                    title: "ライセンス認証",
                    message: "ライセンスを有効化出来ません。("+result+")",
                    buttonYes: "戻る",
                    buttonNo: ""
                })
            }
        }
    }
</script>
